const TARGET_TICK_COUNT = 8;

export const buildTickLabelInterval = (
  totalPoints: number,
): ((value: string, index: number) => boolean) | 'auto' => {
  if (totalPoints <= TARGET_TICK_COUNT) return 'auto';
  const step = Math.ceil((totalPoints - 1) / (TARGET_TICK_COUNT - 1));
  const lastIndex = totalPoints - 1;
  const lastSteppedIndex = Math.floor(lastIndex / step) * step;

  return (_value: string, index: number) => {
    if (index === 0 || index === lastIndex) {
      return true;
    }

    if (index === lastSteppedIndex && lastSteppedIndex === lastIndex - 1) {
      return false;
    }

    return index % step === 0;
  };
};
